/**
 * 组织管理相关 API（对接 tRPC 后端 trpc.samples.deeptutor.Admin）
 */
import { http } from '@/utils';

const Api = {
    List: '/ListOrgs',
    Create: '/CreateOrg',
    Update: '/UpdateOrg',
    Delete: '/DeleteOrg',
};

/** 组织树 */
export async function listOrgs(): Promise<API.OrgInfo[]> {
    const response = await http.post<API.ListOrgsRsp>(Api.List, {});
    return response?.Data?.Items || [];
}

/** 新建组织 */
export async function createOrg(params: API.CreateOrgReq): Promise<API.OrgInfo> {
    const response = await http.post<API.OrgInfo>(Api.Create, params);
    return response?.Data || {};
}

/** 更新组织 */
export async function updateOrg(params: API.UpdateOrgReq): Promise<API.OrgInfo> {
    const response = await http.post<API.OrgInfo>(Api.Update, params);
    return response?.Data || {};
}

/** 删除组织（软删除） */
export async function deleteOrg(params: API.DeleteOrgReq): Promise<void> {
    await http.post(Api.Delete, params);
}
